<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/dan1.png" class="steps step1" v-if="status==1">
			<img src="../../assets/images/dan2.png" class="steps step2" v-if="status==2">
			<img src="../../assets/images/dan3.png" class="steps step3" v-if="status==3">
			<img src="../../assets/images/dan4.png" class="steps step4" v-if="status==4">
			<img src="../../assets/images/dan5.png" class="steps step5" v-if="status==5">
			<img src="../../assets/images/dan6.png" class="steps step6" v-if="status==6">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"下一步":status==3?"下一步":status==4?"下一步":status==5?"下一步":status==6?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'PR采购单列表 '}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
			<div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="　　采购申请编号" style="width: 50%;">
								<el-input v-model="formInline.banfn" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="产品编码" style="width: 50%;">
								<el-input v-model="formInline.matnr" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
                  <el-form-item label="采购组" class="h-elformWrap-2" prop="ekgrp">
                    <mdmselect
                        clearable
                        :showcode="true"
                        category="YLPurchaseGroup"
                        :v="formInline.ekgrp"
                        v-model="formInline.ekgrp">
                    </mdmselect>
                  </el-form-item>

                  <el-form-item label="采购组织" class="h-elformWrap-2" prop="ekorg">
                    <brselect
                        clearable
                        category="purchase_org_code"
                        :v="formInline.ekorg"
                        v-model="formInline.ekorg">
                    </brselect>
                  </el-form-item>

									<el-form-item label="　供应商" >
										<el-input v-model="formInline.fliefName" placeholder="请输入"></el-input>
									</el-form-item>

                  <el-form-item label="采购订单号">
                    <el-input v-model="formInline.apon" placeholder="请输入"></el-input>
                  </el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
<!--									<el-form-item label="SAP采购订单号">-->
<!--										<el-input v-model="formInline.sapcode" placeholder="请输入"></el-input>-->
<!--									</el-form-item>-->
                  <el-form-item label="需求日期" style="width: 50%;">
                    <el-date-picker
                        placeholder="请选择"
                        v-model="formInline.badatbegin"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd" >
                    </el-date-picker>
                    <span class="w-time-to">至</span>
                    <el-date-picker
                        placeholder="请选择"
                        v-model="formInline.badatend"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd" >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="创建日期" style="width: 50%;">
                    <el-date-picker
                        placeholder="请选择"
                        v-model="formInline.createdbegin"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd" >
                    </el-date-picker>
                    <span class="w-time-to">至</span>
                    <el-date-picker
                        placeholder="请选择"
                        v-model="formInline.createdend"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd" >
                    </el-date-picker>
                  </el-form-item>
								</div>
							</div>
						</el-collapse-transition>

						<!-- <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen h-mr20" icon="el-icon-plus" style="width:2rem;" v-auth="'addCgOrder'" @click="newCgOrder">
                                新增采购订单
                            </el-button>
                        </div> -->
					</el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
<!--							<el-button class="h-btn h-formBtn h-bggreen h-mr20" icon="el-icon-plus" style="width:2rem;" v-auth="'addCgOrder'" @click="newCgOrder">-->
<!--							    生成采购订单-->
<!--							</el-button>-->
						</div>
					</div>
				</div>
			</div>
            <div class="h-row purchaselist">
				<div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange"
                            :data="tableData"
                            :span-method="objectSpanMethod"
                            stripe
                            :row-style="cellstyle"
                            style="width: 100%"
                            :border="true"
                            max-height="450"
                    >
                        <el-table-column
							type="selection"
							width="40"
							fixed >
                        </el-table-column>
                        <el-table-column
							type="index"
							width="40"
							label="#"
							fixed
                        >
                        </el-table-column>
                        <el-table-column
							prop="banfn"
							label="采购申请编号"
							:show-overflow-tooltip="true"
							width="110"
							fixed
                        >
                        </el-table-column>

                    	<el-table-column
                            prop="bnfpo"
                            label="行项目编号"
                            :show-overflow-tooltip="true"
                            width="100"
                            fixed
                            >
                        </el-table-column>

                        <el-table-column
							prop="badat"
							label="需求日期"
							:show-overflow-tooltip="true"
							width="110"
							fixed
                        >
                        </el-table-column>
                        <el-table-column
                            prop="matnr"
                            label="产品编码"
                            width="110"
                    		:show-overflow-tooltip="true"
                            fixed
						>
                        </el-table-column>
                    	<el-table-column
							prop="matnrName"
							label="产品名称"
							:show-overflow-tooltip="true"
							width="100"
                    	>
                    	</el-table-column>
                        <el-table-column
                            prop="txz01"
                            label="产品型号"
                    		:show-overflow-tooltip="true"
                            width="90"
						>
                        </el-table-column>
                    	<el-table-column
							prop="menge"
							label="需求数量"
							:show-overflow-tooltip="true"
							width="90">
                    	</el-table-column>
                    	<el-table-column
                          prop="ekorg"
							label="采购组织"
							:show-overflow-tooltip="true"
							width="210"
                    	>
                        <template scope="scope">
                          <div style="text-align: center;">
                            {{ scope.row.ekorg==null?'':'【' }}{{scope.row.ekorg}}{{ scope.row.ekorg==null?'':'】' }}{{scope.row.ekorgName}}
                          </div>
                        </template>
                    	</el-table-column>
                        <el-table-column
							prop="ekgrp"
							label="采购组"
							:show-overflow-tooltip="true"
							width="180">
                          <template scope="scope">
                            <div style="text-align: center;">
                              {{ scope.row.ekgrp==null || scope.row.ekgrp==""?'':'【' }}{{scope.row.ekgrp}}{{ scope.row.ekgrp==null || scope.row.ekgrp==""?'':'】'}}{{scope.row.ekgrpName}}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="fliefName"
                            label="供应商"
                            :show-overflow-tooltip="true"
                            width="200"
						>
                    	</el-table-column>
                    	<el-table-column
							prop="created"
							label="创建日期"
							width="100"
							:show-overflow-tooltip="true"
                    	>
                        <template scope="scope">
                          <div style="text-align: center;">
                            {{scope.row.created.substring(0,10)}}
                          </div>
                        </template>
                    	</el-table-column>
                    	<el-table-column
                    	    prop="apon"
                    	    label="采购订单号"
                    	    width="120"
						>
                    	</el-table-column>
<!--                        <el-table-column-->
<!--                            prop="sapcode"-->
<!--                            label="SAP采购订单号"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                            width="180"-->
<!--						>-->
<!--                        </el-table-column>-->

                        <el-table-column
                        label="操作"
						fixed="right"
						width="120"
                        >
                        <template slot-scope="scope">
							<div style="text-align: center;">
								<el-button
								v-if="scope.row.status == 0 && scope.row.source == 1"
								type="text"
								size="small"
								@click="editPage(scope.row)"
								class="h-tableLink h-btn">
										编辑
								</el-button>

                                <!--
								<el-button
									v-if="scope.row.status == 1 && _user.usercode == scope.row.cgjlcode"
									type="text"
									size="small"
									@click="getDetailEdit(scope.row.orderId, scope.row.instid)"
									class="h-tableLink h-btn">
										编辑
								</el-button>
								-->

								<!--<el-button-->
								<!--type="text"-->
								<!--size="small"-->
								<!--class="h-tableLink h-btn">-->
										<!--删除-->
								<!--</el-button>-->
	<!--							<el-button-->
	<!--							type="text"-->
	<!--							size="small"-->
	<!--							@click="selectProSupplier(scope.row)"-->
	<!--							class="h-tableLink h-btn">-->
	<!--							        供应商商品占比-->
	<!--							</el-button> -->
								<el-button
										type="text"
										size="small"
										@click="getDetailAdd(scope.row.id)"
                    v-if='scope.row.apon==null'
										class="h-tableLink h-btn"
                style="">
									生成采购订单
								</el-button>
								<el-button
										type="text"
										v-if="scope.row.shenpiflag"
										size="small"
										@click="approve(scope.row)"
										class="h-tableLink h-btn">
									审批
								</el-button>

								<el-button v-if='scope.row.status == 3 && (scope.row.waybillType == "2"||scope.row.waybillType == "3")'
								type="text"
								size="small"
								@click="fahuo(scope.row.cgId,scope.row.code)"
								class="h-tableLink h-btn">
									  发货
								</el-button>

								<el-button v-if='(scope.row.status == 4||scope.row.status == 5) && (scope.row.waybillType == "2"||scope.row.waybillType == "3")'
								type="text"
								size="small"
								@click="updateWaybillId(scope.row)"
								class="h-tableLink h-btn">
									  物流维护
								</el-button>


								<el-button v-if='scope.row.status == 4 && ((scope.row.waybillType == "2"&& scope.row.fahuoflag)||scope.row.waybillType == "3")'
										   type="text"
										   size="small"
										   @click="shouhuoSh(scope.row.cgId, scope.row.count, scope.row.receivedCount, (scope.row.count-scope.row.receivedCount),scope.row.code)"
										   class="h-tableLink h-btn">
									 收货
								</el-button>

								<el-button v-if="scope.row.instid != null && scope.row.instid != ''"
										size="small" class="h-tableLink h-btn"
										@click="genzongLiuch(scope.row.instid)">
									跟踪
								</el-button>

                                <!--
								<el-button
										type="text"
										v-if="scope.row.status >= 3 && scope.row.status <= 5 && scope.row.source == 0 && _user.usercode == scope.row.cgjlcode"
										v-auth="'chehui'"
										size="small"
										@click="chehui(scope.row)"
										class="h-tableLink h-btn">
									撤回
								</el-button>

								<el-button
										v-if="scope.row.status <= 6 && scope.row.source == 1"
										v-auth="'deleteCgOrder'"
										size="small" class="h-tableLink h-btn"
										@click="deleteCgOrder(scope.row)">
									撤销
								</el-button>
								-->

								<el-button
										type="text"
										v-if="scope.row.status == 3 && scope.row.orderCode != null && _user.usercode == scope.row.cgjlcode"
										v-auth="'chehui'"
										size="small"
										@click="chehui(scope.row)"
										class="h-tableLink h-btn">
									撤回
								</el-button>

								<el-button
										v-if="scope.row.status < 4 && scope.row.orderCode == null && scope.row.ycId == null"
										v-auth="'deleteCgOrder'"
										size="small" class="h-tableLink h-btn"
										@click="deleteCgOrder(scope.row)">
									撤销
								</el-button>

							</div>

							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-xg" v-if="scope.row.status == 0 && scope.row.source == 1" title="编辑" @click="editPage(scope.row.cgId)"></span>
								<span class="l-operationlist br-operation-look" title="查看" @click="getDetail(scope.row.cgId)"></span>
								<span class="l-operationlist br-operation-sp" v-if="scope.row.shenpiflag" title="审批" @click="approve(scope.row)"></span>
								<span class="l-operationlist br-operation-fh" v-if='scope.row.status == 3 && (scope.row.waybillType == "2"||scope.row.waybillType == "3")' title="发货" @click="fahuo(scope.row.cgId,scope.row.code)"></span>
								<span class="l-operationlist br-operation-wlwh"v-if='(scope.row.status == 4||scope.row.status == 5) && (scope.row.waybillType == "2"||scope.row.waybillType == "3")'  title="物流维护" @click="updateWaybillId(scope.row)"></span>
								<span class="l-operationlist br-operation-sh" v-if='scope.row.status == 4 && (scope.row.waybillType == "2"||scope.row.waybillType == "3") && scope.row.fahuoflag' title="收货" @click="shouhuoSh(scope.row.cgId, scope.row.count, scope.row.receivedCount, (scope.row.count-scope.row.receivedCount),scope.row.code)"></span>
								<span class="l-operationlist br-operation-spgz" v-if="scope.row.instid != null && scope.row.instid != ''" title="跟踪审批" @click="genzongLiuch(scope.row.instid)"></span>
								<span class="l-operationlist br-operation-zf" v-if="scope.row.status < 4||scope.row.status == 6" title="作废" @click="deleteCgOrder(scope.row)"></span>
							</div> -->
						</template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30" >
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                            <el-button style="display: none" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="allWaybillCommit">批量维护物流信息</el-button>
                            <!--<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon" @click="invoice">发票信息维护</el-button>-->
                            <!-- <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button> -->
                            <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
											 clsname="orderCgImportExcel" :startrow="3" @callback="uploadExcelFilecallback"/>
							<el-button class="h-btn h-formBtn h-bgblueQ" style="display: none" v-auth="'gongysfukuan'" @click="cgPayment">供应商付款</el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

		<!--商品-供应商占比-->
		<el-dialog
				:visible.sync="showFujian"
				v-if="showFujian"
				class="h-dialog2"
		>
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>采购订单供应商产品占比</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;overflow: scroll">
				<h3>商品编码</h3><h6>{{proSupplier.productNo}}</h6>
				<h3>商品名</h3><h6>{{proSupplier.productDes}}</h6>
				<h3>产品总量</h3><h6>{{proSupplier.total}}</h6>
				<h3>供应商数量</h3><h6>{{proSupplier.num}}</h6>
				<h3>供应商占比</h3><h6>{{proSupplier.proportion}}</h6>
			</div>
		</el-dialog>


		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 wuliu">
		    <div class="h-dialogImg">
		        <div class="h-disTable">
		            <div class="h-tableCell">
		                <h1>维护发货物流信息</h1>
		            </div>
		        </div>
		    </div>
		    <div class="h-formLine">
		        <el-form ref="form" :model="fh" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item  label="采购单号" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="fh.code" readonly></el-input>
					</el-form-item>
		            <el-form-item label="物流单号" class="h-elformWrap-2" style="width: 100%;">
		               <el-input v-model="fh.waybillId" placeholder="请填写物流单号"></el-input>
		            </el-form-item>
					<el-form-item label="机编码" class="h-elformWrap-2" style="width: 100%;">
					   <el-input v-model="fh.machineCode" placeholder="多个请以逗号分隔"></el-input>
					</el-form-item>
					<el-form-item label="上传附件" class="h-elformWrap-2" style="width: 100%;">
					   <brupload :refid="fh.code" reftype="采购订单发货附件" :showtime="false" uploadflag delflag></brupload>
					</el-form-item>
		        </el-form>
		    </div>
		    <div slot="footer" class="dialog-footer">
		    	<el-button class="h-btn h-formBtn h-bgwhite" @click="cancel">取消</el-button>
		    	<el-button class="h-btn h-formBtn h-bgblueQ2" @click="saveTo">确定</el-button>
		    </div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisiblePay" class="h-dialog2 wuliu">
        		    <div class="h-dialogImg">
        		        <div class="h-disTable">
        		            <div class="h-tableCell">
        		                <h1>维护发票信息</h1>
        		            </div>
        		        </div>
        		    </div>
        		    <div class="h-formLine">
        		        <el-form ref="form" :model="fh1" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
        					<el-form-item label="发票号" class="h-elformWrap-2" style="width: 100%;">
                            <el-input v-model="fh1.code" placeholder="请填写发票号"></el-input>
                            </el-form-item>
                            <el-form-item label="发票日期" class="h-elformWrap-2" style="width: 100%;">
                            <el-date-picker style="width: 100%;"
                            	placeholder="请选择"
                                v-model="fh1.date"
                            		clearable
                            	type="date"
                            	value-format="yyyy-MM-dd" >
                            	</el-date-picker>
                            	</el-form-item>
        					<el-form-item label="上传附件" class="h-elformWrap-2" style="width: 100%;">
        					   <brupload :refid="fh1.code" reftype="发票维护附件" :showtime="false" uploadflag delflag></brupload>
        					</el-form-item>
        		        </el-form>
        		    </div>
        		    <div slot="footer" class="dialog-footer">
        		    	<el-button class="h-btn h-formBtn h-bgwhite" @click="cancel1">取消</el-button>
        		    	<el-button class="h-btn h-formBtn h-bgblueQ2" @click="saveTo1">确定</el-button>
        		    </div>
        		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisibleSh" class="h-dialog2 wuliu">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>维护收货信息</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine">
				<el-form ref="form" :model="sh" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
					<el-form-item  label="采购单号" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="sh.code" readonly></el-input>
					</el-form-item>
					<el-form-item label="总数量" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="sh.count" readonly></el-input>
					</el-form-item>
					<el-form-item label="已收货数量" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="sh.receivedCount" readonly></el-input>
					</el-form-item>
					<el-form-item label="待收货数量" class="h-elformWrap-2" style="width: 100%;">
						<el-input v-model="sh.notreceivedCount"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="cancelSh">取消</el-button>
				<el-button class="h-btn h-formBtn h-bgblueQ2" @click="saveToSh">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="撤销订单" :visible.sync="zfyydialogFormVisible">
		    <el-form :model="zuofeiyy">
		        <el-form-item label="撤销原因" :label-width="100">
		            <brselect category="DD_ZFYY" :v="zuofeiyy.yy"
		                      v-model="zuofeiyy.yy" ></brselect>
		        </el-form-item>
		        <el-form-item label="备注" :label-width="100">
		            <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
		        </el-form-item>
		    </el-form>
		    <div slot="footer" class="dialog-footer">
		        <el-button class="h-btn h-bBtn h-bgwhite" @click="zfyydialogFormVisible = false">取 消</el-button>
		        <el-button class="h-btn h-bBtn" @click="submitzuofei">确 定</el-button>
		    </div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="供应商付款" width="55%" :visible.sync="orderCgPayment" class="h-dialog">
			<div class="h-formLine" style="padding: 0.5rem 0.4rem 0 0.4rem;">
		        <div class="h-disTable" style="margin-bottom: 0.2rem;">
		            <div class="h-tableCell">
		                <span style="font-size: 0.2rem;">{{gysName}}</span>
		            </div>
		        </div>
				<el-table
						ref="multipleTable"
						@selection-change="handleSelectionChangeFK"
						:data="cgPaymentData"
						style="width: 100%"
						:border="true"
				>
					<el-table-column
							type="selection"
							width="40"
					>
					</el-table-column>
					<el-table-column
							type="index"
							width="40"
							label="#"
					>
					</el-table-column>
					<el-table-column
							prop="code"
							label="采购订单号"
							width="130"
							:show-overflow-tooltip="true"
					>
					</el-table-column>
					<el-table-column
							prop="orderCode"
							label="销售订单号"
							:show-overflow-tooltip="true"
							width="130"
					>
					</el-table-column>
					<el-table-column
							prop="code"
							label="付款进度"
							:show-overflow-tooltip="true"
							width="100"
					>
						<template slot-scope="scope">
							{{scope.row.payNum}}/{{scope.row.totalPayNum}}
						</template>
					</el-table-column>
					<el-table-column
							prop="payAmount"
							label="本月应付"
							:show-overflow-tooltip="true"
							width="100"
					>
					</el-table-column>
					<el-table-column
							prop="payAmount"
							label="付款单号"
							:show-overflow-tooltip="true"
							width="100"
					>
					<template slot-scope="scope">
						{{scope.row.paymentOrderNo||'/'}}
					</template>
					</el-table-column>
					<el-table-column
							prop="invoiceno"
							label="发票附件"
							:show-overflow-tooltip="true"
					>
						<template slot-scope="scope">
							<brupload v-if="scope.row.isNeedcred == 1"
									  :refid="scope.row.invoiceno"
									  :reftype=cgfkpz
									  :showtime="false"
									  delflag
									  @filecallback=addfilecallbackpo>
							</brupload>
						</template>
					</el-table-column>
				</el-table>
				<div class="xuanding" v-if="yxamount > 0" style="font-size: 0.2rem;margin-top: 0.3rem;">
					选定付款总额：
					<span class="allmoney"><span style="font-size: 0.22rem;">{{yxamount}}</span>元</span>
				</div>
			</div>

			<div class="h-txtCenter h-mrt60">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="cancelcg">取消</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="sumitfk">确认提交</el-button>
			</div>
		</el-dialog>
		<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
	</div>
</template>
<script>
	import big from 'big.js'
    import ss from '../../api/SystemService'
    import util from "../../utils/util"
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
export default {
    components: {
        uploaddownexcel,
    },
    data(){
        return{
			// 展开折叠筛选
			isScreen:false,
			closeScreen:require("@/assets/images/pimg/closeallic.png"),
			drawScreen:require("@/assets/images/pimg/dobleArr.png"),
			yxamount:'',
            gysName:null,
			cgfkpz: '发票维护附件',
			cgPaymentData:[],
			orderCgPayment:false,
            //导入Excel
            uploaddownexcelflag: false,
            ddhB:'',
            ddhC:'',

			proSupplier:{},
			showFujian: false,
			//游标集
			spanArr:[],

			//游标定位
			position:'',
            checked:true,
            showOrhide:false,
			toshow:'purchaselist',
            status:1,
            names:'',
            input1:'',
            sele:'采购订单',
            formInline:{
              banfn:"",// 采购申请编码
              matnr:'',// 产品编码
              ekgrp:"",// 采购组
              ekorg:"",// 采购组织
              fliefName:"",// 供应商
              apon:"",// 采购订单号
              // sapcode:"",// SAP采购订单号
              badatbegin:null,// 需求日期
              badatend:null,// 需求日期
              createdbegin:null,// 创建日期
              createdend:null,// 创建日期
              pageSize:10,
              pageNo:1,
            },
			options2:[],
            multipleSelection: [],
			checkList:[],
            fh:{
				machineCode:"",
                waybillId:"",
				cgId:"",
				code:""
			},
			fh1:{

            				code:"",
            				date:""
            			},
            sh:{
                cgId:"",
				code:"",
                count:"",
                receivedCount:"",
                notreceivedCount:""
            },
            //列表
            tableData: [],
            q: {
                neixiaoStatus:'neixiao',
                pageSize:10,
                pageNo:1,
                total:0
            },
			p:{
				invoiceno:null,
				invoicedate:null,
				idlist:[],
			},
            isCheck: false,
			dialogFormVisible:false,
            dialogFormVisibleSh:false,
            dialogFormVisiblePay:false,
            showhistory:false,
            instid:null,
			//作废原因
			zfyydialogFormVisible:false,
			zuofeiyy:{
			    id:null,
			    yy:null,
			    bz:null,
			},
        }
    },
    created(){
		this.showzhezhao()
        this.options2 = this.$store.getters.dicts["cg_status"];
	},
    handleFilter() {
        this.query();
    },
    methods:{
      getDisabled(prmid) {
        return true;
        // this.$router.push({path: '/dingd/orderCreatePR',query:{id: orderId}});
      },
      getStyle(prmid) {
        console.log(prmid)
        // this.$router.push({path: '/dingd/orderCreatePR',query:{id: orderId}});
      },
		// 展开折叠
		collapseChange(){
			this.isScreen = !this.isScreen;
		},
		getCheckAmount() {
			var amount = 0;
			this.checkList.forEach(function(item, key) {
				// amount += item.payAmount
				amount = new big(amount).plus(item.payAmount);
			})
			this.yxamount = amount;
		},
		addfilecallbackpo(v) {
			var list = this.list;
			_.forEach(this.list, function(item, key) {
				_.forEach(v, function(item1) {
					if (item1.refid == item.id && item1.reftype == "发票维护附件") {
						list[key].pzfileFlag = 1;
						return false;
					}
				})
			})
			this.list = list;
		},
    	//供应商付款（弹窗式）
		cgPayment(){
			var noflag = true;
			var cgIdList = [];
			//校验是否都有发票号
			if(this.multipleSelection.length>0){
				var suserCode = this.multipleSelection[0].suserCode;
				this.multipleSelection.forEach(element => {
					if(element.status==5){
						if(suserCode==element.suserCode){
							cgIdList.push(element.cgId);
						}else{
							this.$msg.msge("所选项不是同一个供应商，请重新选择！");
							noflag =false;
							return false;
						}
					}else{
						this.$msg.msge("所选项中有订单未确认收货，请重新选择！");
						noflag = false;
						return false;
					}
				});
			}else{
				this.$msg.msge("请选择付款采购订单！");
				noflag=false;
				return;
			}
			if(noflag){
				ss.orderCgService.getCgPaymentList(cgIdList).then(rd => {
					this.cgPaymentData = rd;
                    this.gysName = rd[0].suserName;
				});
				this.orderCgPayment = true;
			}
		},
		cancelcg() {
			this.orderCgPayment = false;
		},
		//供应商确认付款
		sumitfk() {
			if (!this.checkList || this.checkList < 1) {
				this.$msg.msge("请选择付款采购订单！");
				return;
			}
			var flag = false;
			this.checkList.forEach(function(item, key) {
				if (item.isPayment == 1) {
					flag = true;
					return false;
				}
			})
			if (flag) {
				this.$msg.msge("付款中采购订单不能重复付款！");
				return;
			}
			ss.orderCgService.saveCgFk(this.checkList).then(rd => {
				if (rd.f) {
					this.$msg.msgs(rd.msg);
				} else {
					this.$msg.msge(rd.msg);
				}
				this.orderCgPayment = false;
			})
		},
		cellstyle(value){
			//console.log(value)
			if(value.row.status == 0 || value.row.status == 1 || value.row.status == 2 || value.row.status == 3){
				return 'font-weight: bold;'
			}
		},
        //导入Excel
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },
        uploadExcelFilecallback(rd) {
            this.query();
            this.$msg.msgs(rd.msg);
        },

		//作废订单
		deleteCgOrder(row) {
		    if (row.status == '0') {
		        this.$msg.confirm("确认撤销?", () => {
		            ss.orderCgService.deleteCgOrder(row.cgId, row.deleteReason).then(rd => {
		                this.$msg.msgs(rd.msg);
		                this.query();
		            });
		        });
		    } else {
		        this.zuofeiyy.id = row.cgId
		        this.zfyydialogFormVisible = true;
		    }
		},

		chehui(row) {
            this.$msg.confirm("确认撤回?", () => {
                ss.orderCgService.chehuiCgOrder(row.cgId).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.query();
                });
            });
		},

		submitzuofei(){
		    if (!this.zuofeiyy.yy) {
		        this.$msg.msge("请选择撤销原因");
		        return false;
		    }
		    var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
		    this.$msg.confirm("确认撤销?", () => {
		        ss.orderCgService.deleteCgOrder(this.zuofeiyy.id, yybz).then(rd => {
		            this.$msg.msgs(rd.msg);
		            this.query();
		            this.zfyydialogFormVisible = false
		        });
		    });
		},
		showzhezhao() {
		    ss.salesList.toshow(this.toshow).then(rd => {
		        console.log(rd)
		        if (rd == false) {
		            this.showOrhide = false;
		        } else {
		            this.showOrhide = true;
		        }
		    })
		},

		//记录游标的方法
		getSpanArr() {

			//游标集，每个元素的下标对应当前页table的每一行的行号，每个元素的数字对应这一行条件相同的共重复了几行
			this.spanArr = [];

			//遍历当前表元素
			this.tableData.forEach((item, index) => {

				//当第一行时
				if (index === 0) {

					//默认先放第一行是1次
					this.spanArr.push(1);

					//记录当前重复行的位置
					this.position = 0;

					//其他行
				} else {

					//如果该行上的zhubiaoid与上一行上的zhubiaoid重复
					if (this.tableData[index].zhubiaoid === this.tableData[index - 1].zhubiaoid) {

						//从游标集中取到记录重复行的那行的重复数字，自增1(又重复一次)
						this.spanArr[this.position] += 1;

						//因为这次重复了，所以放入0记录作为这行实际上应该被合并掉
						this.spanArr.push(0);

						//若不重复
					} else {

						//继续向游标集放入一个1作为本行没有重复的独立一次记录
						this.spanArr.push(1);

						//记录重复行位置的游标移动到本行位置
						this.position = index;

					}
				}
			})
		},

		//合并单元行方法
		objectSpanMethod({row, column, rowIndex, columnIndex}) {


			//需要合并单元行的是哪几列
			if (column.label=="采购主表id") {

				//从游标集取到对应行下标位置的行重复记录数字，作为需要被合并多少行的rowspan数(该行跨了几行)
				const _row = this.spanArr[rowIndex];

				//该行跨了几列
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				}
			}

		},

        closeIt(){
			this.showOrhide = false;
			if (this.checked) {
			    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
			        console.log(rd)
			        this.showOrhide = false;
			    })
			} else {
			    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
			        console.log(rd)
			        this.showOrhide = false;
			    })
			}
		},
		nextStep(i){
			console.log(i)
			if(this.status ==1){
					this.status = 2;
			}else if(this.status ==2){
					this.status = 3;
			}else if(this.status ==3){
					this.status = 4;
			}else if(this.status ==4){
					this.status = 5;
			}else if(this.status ==5){
					this.status = 6;
					document.documentElement.scrollTop = 300;
			}else if(this.status ==6){
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			}
		},
        //表格
        handleSelectionChange(val) {
            this.multipleSelection = val;
            var str = '';
            var str2 = '';
            this.multipleSelection.forEach(element => {
                str += element.cgId + ',';
                str2 += element.code + ',';
            });
            str = str.substring(0,str.length-1);
            str2 = str2.substring(0,str2.length-1);
            this.ddhB = str;
            this.ddhC = str2;
        },
		//表格
		handleSelectionChangeFK(val) {
			this.checkList = val;
			var amount = 0;
			this.checkList.forEach(function(item, key) {
				// amount += item.payAmount
				amount = new big(amount).plus(item.payAmount);
			})
			this.yxamount = amount;
		},
        //检索按钮功能
        checkData(){
            this.q.pageNo = 1;
            this.query();
        },
        //重置按钮功能
        resetData(){
          this.formInline.banfn = "";// 采购申请编码
          this.formInline.matnr = "";// 产品编码
          this.formInline.ekgrp = "";// 采购组
          this.formInline.ekorg = "";// 采购组织
          this.formInline.fliefName = "";// 供应商
          this.formInline.apon = "";// 采购订单号
          // this.formInline.sapcode = "";// SAP采购订单号
          this.formInline.badatbegin = null;// 需求日期
          this.formInline.badatend = null;// 需求日期
          this.formInline.createdbegin = null;// 创建日期
          this.formInline.createdend = null;// 创建日期
          this.q.pageSize = 10;
          this.query();
        },
        newCgOrder() {
            this.$router.push({path: '/dingd/orderCreate'});
		},
        payment() {
            this.$router.push("/dingd/orderCgPayment");
		},
      query(p) {
        this.q.ids=null;
        this.q.banfn = this.formInline.banfn;// 采购申请编码
        this.q.matnr = this.formInline.matnr;// 产品编码
        this.q.ekgrp = this.formInline.ekgrp;// 采购组
        this.q.ekorg = this.formInline.ekorg;// 采购组织
        this.q.fliefName = this.formInline.fliefName;// 供应商
        this.q.apon = this.formInline.apon;// 采购订单号
        // this.q.sapcode = this.formInline.sapcode;// SAP采购订单号
        this.q.badat = this.formInline.badatbegin;// 需求日期
        this.q.lfdat = this.formInline.badatend;// 需求日期
        this.q.created = this.formInline.createdbegin;// 创建日期
        this.q.lasted = this.formInline.createdend;// 创建日期
        ss.orderCgService.selectPagePR(this.q).then(rd => {
             this.q.total = rd.total;
             this.tableData = rd.records;
             this.getSpanArr();
        });
      },
        //编辑
        editPage(v){
			if(v.ycId){
				this.$router.push({path: '/dingd/orderCreateYC',query:{cgId:v.cgId}});
			}else{
				this.$router.push({path: '/dingd/orderCreate',query:{cgId:v.cgId}});
			}
        },
		//查询供应商商品占比
		selectProSupplier(x){
			this.proSupplier = {};
			ss.orderCgService.selectProSupplier(x).then(rd => {
				this.proSupplier = rd;
				console.log('我在这儿呀1', this.proSupplier.id);

				if(this.proSupplier.id){
					this.showFujian = true;
				}
			})
		},

        getDetail(id) {
            this.$router.push({path: '/dingd/orderThrough',query:{cgId:id}});
		},
        getDetailEdit(orderId, instid) {
            this.$router.push({path: '/dingd/orderCgApprove',query:{ywid: orderId, instid: instid}});
        },

      getDetailAdd(orderId) {
        this.$router.push({path: '/dingd/orderCreatePR',query:{id: orderId}});
      },
        approve(row) {
            this.$router.push({
                path: row.dburl,
                query: {ywid: row.cgId,taskid:row.taskId, instid: row.instid, taskstatus: '0', link: 1}
            });
		},
        //明细导出
        exportExcel() {

            // var idlist=[];
            // this.multipleSelection.forEach(element => {
            //     idlist.push(element.cgId);
            // });
            // if (idlist) {
            //     this.q.ids = idlist.join(",");
            // } else {
            //     this.q.ids ='';
            //
            // }
            // this.q.cgId = this.formInline.cgId
            // this.q.suserName = this.formInline.suserName
            // this.q.status = this.formInline.status

            updownfile.down("/api/swyl/v1/dingd/bsc/OrderCg/downloadExcel",this.q,"post",'params');

        },

        allWaybillCommit() {
            if(this.ddhB == ''){
                this.$msg.msge("请勾选维护物流信息的订单!!!");
                return false;
            }
            var flag1 = true;
            this.multipleSelection.forEach((item, index) => {
                if(!((item.status == 4||item.status == 5)&&(item.waybillType == "2"||item.waybillType == "3"))){
                    flag1 = false;
                    return;
                }
            })
            if(!flag1){
                this.$msg.msge("存在不满足维护物流信息条件的订单，请检查勾选项!");
                return;
            }
            this.fh.code= this.ddhC;
            this.fh.cgId= this.ddhB;
            this.fh.waybillId = '';
            this.fh.waybillName = '';
            this.fh.waybillDate = '';
            this.fh.machineCode = '';
            this.dialogFormVisible = true;
        },

		fahuo(v,code) {
			this.$msg.confirm("确认要发货吗？",()=>{
				this.fh.cgId = v;
				//更新发货信息
				ss.orderCgService.fahuo(this.fh).then(rd => {
					this.$msg.msgs(rd.msg)
				});
			})
		},
		updateWaybillId(data){
		    console.log(data);
			this.dialogFormVisible = true ;
			this.fh.cgId= data.cgId;
			this.fh.code= data.code;
			this.fh.waybillId = data.waybillId;
			this.fh.machineCode = data.machineCode;
		},
		invoice(){
			var noflag = true;
			//校验是否都有发票号
			if(this.multipleSelection.length>0){
				var invoiceno = this.multipleSelection[0].invoiceno;
				var invoicedate = this.multipleSelection[0].invoicedate;
				var cgfpno = invoiceno;
				var cgfkdate = invoicedate;
				this.multipleSelection.forEach(elements=>{
					var invoice = elements.invoiceno;
					var invoiceda = elements.invoicedate;
					if(elements.status ==5){
						if(invoiceno && invoice){
							cgfpno = invoice;
							cgfkdate = invoiceda;
							if(invoiceno !=invoice){
								this.$msg.msge("所选项的发票号不同，不允许同时维护，请重新选择！");
								noflag =false;
							}
							if(noflag){
								return false;
							}
						}
					}else if(elements.status !=5){
						if(noflag){
							this.$msg.msge("所选项中有订单尚未确认收货，请重新选择！");
							noflag =false;
						}
						if(noflag){
							return false;
						}
					}
				})
			}else{
				this.$msg.msge("请选择要维护发票的采购订单！");
				noflag=false;
				return false;
			}
		if(noflag){
				this.dialogFormVisiblePay = true ;
				this.fh1.code= cgfpno;
				this.fh1.date= cgfkdate;
			}
		},
		cancel() {
            this.dialogFormVisible = false ;
		},
		cancel1() {
                    this.dialogFormVisiblePay = false ;
        		},
        saveTo() {
            this.fh.code="";
			//更新发货信息
            ss.orderCgService.updateWaybillId(this.fh).then(rd => {
				this.$msg.msgs(rd.msg)
            });
            this.dialogFormVisible = false;
			this.query();
		},
		saveTo1(){
        this.p.invoiceno=this.fh1.code;
        this.p.invoicedate=this.fh1.date;
        var idlist=[];
        this.multipleSelection.forEach(element => {
                                idlist.push(element.cgId);
                            });
        this.p.idlist = idlist;
                           /* if (idlist) {
                                this.q.ids = idlist.join(",");
                                console.log("qqqqqqqqqqqqqq",this.q.ids)
                            } else {
                                this.q.ids ='';
                            }*/
            ss.orderCgService.saveInvoicePage(this.p).then(rd => {
            				this.$msg.msgs(rd.msg);
							this.dialogFormVisiblePay = false;
							this.query();
                        });


		},
		shouhuoSh(v,vv,vvv,vvvv,code) {
			// console.log("1111111",v);
            this.dialogFormVisibleSh = true;
            this.sh.cgId = v;
            this.sh.count = vv;
            this.sh.receivedCount = vvv;
            this.sh.notreceivedCount = vvvv;
            this.sh.code=code;
		},
        cancelSh() {
            this.dialogFormVisibleSh = false ;
        },
        saveToSh() {
            //更新发货信息
            ss.orderCgService.updateCount(this.sh).then(rd => {
                if (rd.f){
                    this.query();
                    this.$msg.msgs(rd.msg)

                }  else {
                    this.$msg.msge(rd.msg)
                }
            });

            this.dialogFormVisibleSh = false ;
		},
        genzongLiuch(r){
            this.instid = r;
            this.showhistory = true;
        },

    },
    mounted() {
        this.query();
	}
}
</script>
<style>
 .wuliu .h-dialogForm .h-elformWrap-2 .el-form-item__label{
	width: 27%;
}
 .wuliu .h-formbLine .h-elformWrap-2{
	width: 100%!important;
}
.purchaselist	.h-tableLink{
		padding:0px!important;
	}
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.steps{
			position: absolute;
			z-index: 1;

		}
		.step1{
			top: 0.8rem;
			left: 0;
			width: 6rem;
			height: 11.5rem;
		}
		.step2{
			top: 1.63rem;
			right: 6.9rem;
			width: 9.4rem;
			height: 1.9rem;
		}
		.step3{
			width: 2.3rem;
			height: 1.9rem;
			right: 3.7rem;
			top: 1.6rem;
		}
        .step4{
			width: 3rem;
			height: 2.3rem;
			right: 0.7rem;
			top: 1.65rem;
		}
        .step5{
			width: 6.25rem;
			height: 1.3rem;
			right: 0.37rem;
			top: 4.25rem;
		}
        .step6{
			width: 3.9rem;
			height: 1.1rem;
			left: 2.6rem;
			top: 7.1rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
